
$( document ).ready(function() {

    if (window.innerWidth <= 768) {
        if(/Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            var dateObj = new Date();
            var month = dateObj.getUTCMonth() + 1;
            var day = dateObj.getUTCDate();
            var year = dateObj.getUTCFullYear();

            var newdate = year + "-" + month + "-" + day;

            $('#edit-birthdate').mobiscroll().datepicker({
                controls: ['date'],
                display: 'bottom',
                theme: 'material',
                themeVariant: 'dark',
                touchUi: true,
                maxWidth: 100000,
                rows: 5,
                // max: newdate,
                onChange: function (event, inst) {
                    var date = inst.getVal();
                    var birthDay = date.getDate();
                    var birthMonth = date.getMonth() + 1;
                    var birthYear = date.getFullYear();
                    $('#birth-day').val(birthDay);
                    $('#birth-month').val(birthMonth);
                    $('#birth-year').val(birthYear);
                }
            });
        }
    }
});

